module.exports = __webpack_public_path__ + "img/2.81fd1df8.png";